// Espelho JS de themis/lib/cnj.py — parse + inferência tribunal/tipo/área.

const CNJ_RE = /^(\d{7})-?(\d{2})\.?(\d{4})\.?(\d)\.?(\d{2})\.?(\d{4})$/;

export function parseCnj(raw) {
  if (!raw) return null;
  const cleaned = String(raw).replace(/\s+/g, '').trim();
  const m = cleaned.match(CNJ_RE);
  if (!m) return null;
  const [, seq, dv, ano, j, tr, oooo] = m;
  return {
    numeroCompleto: `${seq}-${dv}.${ano}.${j}.${tr}.${oooo}`,
    sequencial: seq,
    dv,
    ano: parseInt(ano, 10),
    orgao: parseInt(j, 10),
    tribunalCodigo: tr,
    varaCodigo: oooo,
  };
}

const UFS = {
  '01':'TJAC','02':'TJAL','03':'TJAP','04':'TJAM','05':'TJBA',
  '06':'TJCE','07':'TJDF','08':'TJES','09':'TJGO','10':'TJMA',
  '11':'TJMT','12':'TJMS','13':'TJMG','14':'TJPA','15':'TJPB',
  '16':'TJPR','17':'TJPE','18':'TJPI','19':'TJRJ','20':'TJRN',
  '21':'TJRS','22':'TJRO','23':'TJRR','24':'TJSC','25':'TJSP',
  '26':'TJSE','27':'TJTO',
};

export function tribunalDe(parsed) {
  const { orgao, tribunalCodigo: tr } = parsed;
  if (orgao === 1) return 'STF';
  if (orgao === 2) return 'CNJ';
  if (orgao === 3) return 'STJ';
  if (orgao === 4) return tr === '00' ? 'TST' : `TRF${parseInt(tr, 10)}`;
  if (orgao === 5) return tr === '00' ? 'TST' : `TRT${parseInt(tr, 10)}`;
  if (orgao === 6) return tr === '00' ? 'TSE' : `TRE-${tr}`;
  if (orgao === 7) return tr === '00' ? 'STM' : `JM-${tr}`;
  if (orgao === 8) return UFS[tr] || `TJ-${tr}`;
  if (orgao === 9) return `JME-${tr}`;
  return `O${orgao}-${tr}`;
}

export function tipoDe(parsed) {
  const o = parsed.orgao;
  if (o === 5) return 'trabalhista';
  if (o === 1 || o === 3 || o === 4 || o === 8) return 'civel';
  if (o === 6) return 'administrativo';
  if (o === 7 || o === 9) return 'penal';
  return null;
}

export function areaDe(parsed, classe = '') {
  const o = parsed.orgao;
  if (o === 5) return 'LABOR';
  const c = (classe || '').toLowerCase();
  if (/execu[çc][aã]o\s+fiscal|tribut[aá]ri|iptu|icms|iss/.test(c)) return 'TAX';
  if (/consumidor|cdc|indeniza[cç][aã]o|avaria/.test(c)) return 'LIT';
  if (/contrato|rescis[aã]o/.test(c)) return 'CONTRACT';
  return 'LIT';
}
